import { render, staticRenderFns } from "./AdminPermission.vue?vue&type=template&id=7591b270&scoped=true"
import script from "./AdminPermission.vue?vue&type=script&lang=js"
export * from "./AdminPermission.vue?vue&type=script&lang=js"
import style0 from "./AdminPermission.vue?vue&type=style&index=0&id=7591b270&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7591b270",
  null
  
)

export default component.exports